import { animate, style, transition, trigger } from '@angular/animations';
import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { AlertAction, AlertPayload, AlertService } from '@core/services/alert.service';
import { IconComponent } from '@shared/components/icon/icon.component';

import { ButtonComponent } from '../../../shared/components/button/button.component';

type ExtraAlertPayload = AlertPayload & { id: string };

@Component({
    selector: 'app-alerts',
    imports: [ButtonComponent, IconComponent],
    templateUrl: 'alerts.component.html',
    styleUrls: ['alerts.component.css'],
    animations: [
        trigger('fade', [
            transition(':enter', [style({ opacity: 0 }), animate(200, style({ opacity: 1 }))]),
            transition(':leave', [style({ opacity: 1 }), animate(200, style({ opacity: 0 }))]),
        ]),
    ],
})
export class AlertsComponent implements OnInit {
    private alertService: AlertService = inject(AlertService);

    public currentAlert: WritableSignal<ExtraAlertPayload | null> = signal(null);

    public ngOnInit(): void {
        this.alertService.$alerts.subscribe((alert) => {
            if (alert) {
                if (alert.id) {
                    if (alert.id === this.currentAlert()?.id) {
                        return;
                    }
                } else {
                    alert.id = Math.random().toString(36).substring(2, 8);
                }

                if (!alert.icon) {
                    alert.icon = null;
                }

                if (!alert.confirmColor) {
                    alert.confirmColor = 'black';
                }

                if (!alert.showCloseButton) {
                    alert.showCloseButton = false;
                }

                if (alert.timer == null) {
                    alert.timer = null;
                }

                this.currentAlert.set(alert as ExtraAlertPayload);

                if (alert.timer) {
                    if (alert.timer === 'default') {
                        alert.timer = 1500;
                    }

                    setTimeout(() => {
                        if (alert.id) this.dismissAlertById(alert.id);
                    }, alert.timer);
                }
            } else {
                this.currentAlert.set(null);
            }
        });

        this.alertService.$alertActions.subscribe((action: AlertAction) => {
            this.dismissAlertById(action.id);
        });
    }

    public dismissAlert(confirmed: boolean | null = null): void {
        const alert = structuredClone(this.currentAlert());
        this.currentAlert.set(null);

        if (alert) {
            setTimeout(() => {
                if (confirmed === true && alert.onConfirm) {
                    alert.onConfirm();
                } else if (confirmed === false && alert.onCancel) {
                    alert.onCancel();
                } else if (alert.onClose) {
                    alert.onClose();
                }
            }, 300);
        }
    }

    public checkBackdropDismiss(): void {
        if (this.currentAlert()?.backdropDismiss === true) {
            this.dismissAlert();
        }
    }

    private dismissAlertById(id: string): void {
        if (this.currentAlert()?.id === id) {
            this.currentAlert.set(null);
        }
    }
}
